import { geoService } from '@/api/urls/_config';

export const geoUrls = {
    // City
    getCities: geoService + '/city',
    getNearestCity: geoService + '/city/nearest',

    // Coverage
    checkCoverage: geoService + '/geo/check-coverage',

    //Address
    getUserAddress: geoService + '/users/address',
    createUserAddress: geoService + '/users/address',
    updateUserAddress: geoService + '/users/address/{{addressId}}',
    deleteUserAddress: geoService + '/users/address/{{addressId}}',
    nearestAddress: geoService + '/users/address/nearest'
};
